<template>
	<div class="gvf">
		<v-select
			:tabindex="tabIndex"
			:disabled="isNull"
			v-model="value"
			:label="gridViewField.Label"
			:items="items"
			class="grid-field"
			hide-details="auto"
			@change="changeValue()"
		/>
		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="changeValue()"
		></v-checkbox>
	</div>
</template>
<script>
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import { approvalStatus } from '../../../../enums/approvalStatus';
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
export default {
	name: 'ApprovalStatusField',
	mixins: [gridFieldMixin],
	data() {
		return {
			items: [
				{ value: approvalStatus.None, text: 'None' },
				{ value: approvalStatus.Approved, text: 'Approved' },
				{ value: approvalStatus.Pending, text: 'Pending' },
			],
			value: null,
		};
	},
	watch: {
		record(newVal) {
			this.value = newVal[this.gridViewField.DataField.FieldName];
		},
	},
	methods: {
		changeValue() {
			let recordKey;
			if (this.isNull) {
				recordKey = [{ key: this.key, value: null }];
				this.value = null;
			} else {
				recordKey = [{ key: this.key, value: this.value }];
			}
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: this.value,
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
	},
};
</script>
